// Dataset type registry.
//
// A type is a reusable definition (label, description, item metadata schema, optional ingestion
// workflow). A dataset created from a type copies those values and keeps them, even if the type
// changes later.
import { adminRequest } from "./adminRequest";

const BASE = "/admin/dataset-types";

const encode = (value) => encodeURIComponent(value ?? "");

/** List types. Only active ones unless `includeInactive`. */
export const getDatasetTypes = async ({ includeInactive = false } = {}) => {
  const query = includeInactive ? "?include_inactive=true" : "";
  const result = await adminRequest("GET", `${BASE}${query}`);

  return {
    ...result,
    dataset_types: Array.isArray(result?.dataset_types) ? result.dataset_types : [],
  };
};

/** Create a type. `name` must match ^[a-z0-9][a-z0-9_-]{0,99}$ and `metadata_schema` is required. */
export const createDatasetType = async (payload) => adminRequest("POST", BASE, payload);

/** Update a type. Existing datasets are not rewritten. */
export const updateDatasetType = async (publicId, payload) =>
  adminRequest("PUT", `${BASE}/${encode(publicId)}`, payload);

/** Deactivate a type (`is_active=false`); existing datasets are unaffected. */
export const deactivateDatasetType = async (publicId) =>
  adminRequest("DELETE", `${BASE}/${encode(publicId)}`);

export default getDatasetTypes;
